<template>
  <div class="career-radio-selector">
    <h4 v-if="title" class="selector-title mb-4">{{ title }}</h4>
    <v-radio-group
      :value="value"
      @change="handleChange"
      :mandatory="mandatory"
      class="career-radio-group"
    >
      <v-card
        v-for="item in normalizedItems"
        :key="item.value"
        :class="[
          'career-card mb-3',
          { 'career-card--selected': item.value === value }
        ]"
        outlined
        @click="selectCareer(item.value)"
      >
        <v-card-text class="d-flex align-center pa-4">
          <v-radio
            :value="item.value"
            :label="item.text"
            color="primary"
            class="career-radio"
          ></v-radio>
        </v-card-text>
      </v-card>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'CareerRadioSelector',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'career'
    },
    itemValue: {
      type: String,
      default: 'legajo'
    },
    title: {
      type: String,
      default: ''
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    normalizedItems() {
      return this.items.map(item => ({
        text: typeof item === 'object' ? item[this.itemText] : item,
        value: typeof item === 'object' ? item[this.itemValue] : item
      }))
    }
  },
  methods: {
    selectCareer(value) {
      if (value !== this.value) {
        this.handleChange(value)
      }
    },
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="sass" scoped>
.career-radio-selector
  width: 100%

.selector-title
  color: var(--v-primary-base)
  font-weight: 600
  font-size: 1rem
  margin: 0

.career-radio-group
  margin-top: 0

.career-card
  cursor: pointer
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
  border: 2px solid #e0e0e0
  background-color: #ffffff

  &:hover
    border-color: var(--v-primary-base)
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)
    transform: translateY(-2px)

  &--selected
    border-color: var(--v-primary-base)
    background-color: rgba(var(--v-primary-base), 0.05)
    box-shadow: 0 2px 12px rgba(var(--v-primary-base), 0.2)

.career-radio
  width: 100%
  margin: 0

  ::v-deep .v-label
    font-size: 1rem
    font-weight: 500
    color: #424242
    width: 100%

  ::v-deep .v-input--selection-controls__input
    margin-right: 12px
</style>
